import React from 'react';
import { StyleSheet, View, Share,TouchableOpacity , Linking, ScrollView} from 'react-native';
import {  IconButton  ,Appbar,Text,Avatar } from 'react-native-paper';

export default class App extends React.Component {
  state = {
    results: []  ,
  };

  _shareText() {
    Share.share({
      message: 'با مربی دلخواهت هر زمان و هر مکان، آنلاین ورزش کن' + ' '+ 'https://fitwayz.ir/' ,
    }, {
      dialogTitle: 'به اشتراک گذاری فیت ویز',
  
      tintColor: 'green'
    })
    .then(this._showResult)
    .catch((error) => this.setState({result: 'error: ' + error.message}));
  }

  _showResult(result) {
    if (result.action === Share.sharedAction) {
      if (result.activityType) {
        this.setState({result: 'shared with an activityType: ' + result.activityType});
      } else {
        this.setState({result: 'shared'});
      }
    } else if (result.action === Share.dismissedAction) {
      this.setState({result: 'dismissed'});
    }
  }
  
  render() {

    return (
      <View style={{backgroundColor:'white', height:'100%'}}>

   <Appbar.Header style={{height:50,backgroundColor:'white',zIndex:100}} >
      <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
      <Appbar.Content title='تنظیمات'/>
      <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
    </Appbar.Header>

    <ScrollView>


    <View style={[styles.divider,{borderColor:'white'}]}>
        <Text style={{marginTop:7, marginBottom:4 , color:'#3a3635'}}>ویرایش مشخصات</Text>
    </View>

    <TouchableOpacity style={{flexDirection:'row',alignItems:'center',marginLeft:30,marginTop:5,marginBottom:20}} onPress={()=>this.props.navigation.navigate('EditUser')}>
      <Avatar.Image size={48} source={{uri : global.image.uri}} />
      <Text style={{marginHorizontal:10  , color:'#3a3635'}}>{global.fname+' '+global.lname}</Text>
      <IconButton icon='account-edit' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} color='#3a3635' />
     </TouchableOpacity>
     

          <View style={styles.divider}>
        <Text style={{marginTop:4, marginBottom:4 , color:'#3a3635'}}>بازخورد</Text>
      </View>
      <TouchableOpacity onPress={()=> Linking.openURL('mailto:fitwayz.group@gmail.com')}>
     <Text style={{marginHorizontal:30, marginBottom:15 ,textDecorationLine:'underline',color:'#1B7479'}}>پیشنهادات خود را با ما در میان بگذارید</Text>
     </TouchableOpacity>

     <View style={styles.divider}>
        <Text style={{marginTop:4, marginBottom:4 , color:'#3a3635'}}>به اشتراک گذاری</Text>
      </View>
      <TouchableOpacity onPress={this._shareText}>
     <Text style={{marginHorizontal:30, marginBottom:15 ,textDecorationLine:'underline',color:'#1B7479'}} >معرفی "فیت ویز" به دوستان</Text>
     </TouchableOpacity>

      <View style={styles.divider}>
        <Text style={{marginTop:4, marginBottom:4 ,color:'#3a3635'}}>پشتیبانی</Text>
      </View>
      <TouchableOpacity onPress={()=> Linking.openURL('tel:09226346525')}>
      <Text style={{marginHorizontal:30, marginBottom:10 ,textDecorationLine:'underline',color:'#1B7479'}}>ارتباط با واحد پشتیبانی</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={()=>{this.props.navigation.navigate('Terms')}}>
      <Text style={{marginHorizontal:30, marginBottom:10 ,textDecorationLine:'underline',color:'#1B7479'}}>شرایط و مقررات</Text>
      </TouchableOpacity>
      <Text style={{marginHorizontal:30, marginBottom:10 }}>نسخه نرم افزار : 2.1.0</Text>

      </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider:{
    backgroundColor :'#fff',
    padding:4,
    marginHorizontal:20,
    borderColor:'grey',
    borderTopWidth:0.3
  },
 

});
